const $inject = ['dataService', '$routeParams', '$scope', '$timeout', '$location'];

const lbaLeafletMapCtrl = function (dataService, $routeParams, $scope, $timeout, $location) {
  let vm = this;
  const dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);
  vm.data = _.get(dataService.data.activeItem, dataLookUp);
  vm.toggleLabels = toggleLabels;
  vm.circles = [];
  vm.popups = [];
  vm.markers = [];
  const defaultIcon = L.icon({
    iconUrl: require('./point-of-interest.png'),
    iconSize: [20,20],
    iconAnchor: [10,5]
  });

  let mapInitialised = false;
  vm.mapId = 'map' + $scope.$id;
  vm.map = null;

  function init() {
    let mapPos = [0, 0];
    let zoomLevel = vm.zoomLevel || 1;

    if (vm.mapCenter) {
      mapPos = [vm.mapCenter.latitude, vm.mapCenter.longitude];
    }

    vm.map = L.map(vm.mapId).setView(mapPos, zoomLevel);

    _.forEach(vm.data, (data, index) => {
      if (data.Longitude !== null && data.Latitude !== null) {
        addRadius(data, index)
      }
    });
    const group = new L.featureGroup(vm.circles);
    if (Object.keys(group.getBounds()).length > 0) {
      vm.map.fitBounds(group.getBounds());
    }

    L.gridLayer.googleMutant({
      type: 'roadmap',
    }).addTo(vm.map);

    vm.map.attributionControl.options.prefix = '';
    mapInitialised = true;
  }

  function addRadius(data, index) {
    const lat = data.Latitude;
    const lng = data.Longitude;
    let radius = data.Radius;

    if (radius === null) {
      radius = 5;
    }
    let pos = [lat, lng];
    vm.circles.push(L.circle(pos, {radius: radius * 1000, lat: lat, long: lng}).addTo(vm.map));
    addPopup(data, index);
  }

  function addPopup(data, index) {
    const lat = data.Latitude;
    const lng = data.Longitude;
    let pos = [lat, lng];
    vm.popups.push(L.popup({closeOnClick: false})
      .setLatLng(pos)
      .setContent(`<a href="${ $location.absUrl()}/policies/${index}">${data.PolicyName} ${ data.LocationCode ? '- ' +  data.LocationCode : ''}</a>`)
      .addTo(vm.map)
    )
  }

  function addPin(data, index) {
    const lat = data.Latitude;
    const lng = data.Longitude;
    let pos = [lat, lng];
    vm.markers.push(L.marker(pos, {icon: defaultIcon}).addTo(vm.map));
  }

  function toggleLabels() {
    if (vm.popups.length > 0) {
      vm.popups.forEach(popup => {
        vm.map.closePopup(popup);
      });
      vm.popups = [];
      _.forEach(vm.data, (data, index) => {
        if (data.Longitude !== null && data.Latitude !== null) {
          addPin(data, index);
        }
      });
    } else {
      vm.markers.forEach(marker => {
        marker.remove();
      });
      vm.markers = [];
      _.forEach(vm.data, (data, index) => {
        if (data.Longitude !== null && data.Latitude !== null) {
          addPopup(data, index);
        }
      });
    }
  }

  $timeout(init);
};

lbaLeafletMapCtrl.$inject = $inject;

export default lbaLeafletMapCtrl;



// WEBPACK FOOTER //
// ./src/components/lbaLatLngMap/lbaLatLngMapCtrl.js